import { Transition, Variants } from 'framer-motion';

const transition: Transition = {
  ease: 'easeInOut',
  duration: 0.25,
};

export const transactionMappingVariants = (boundings: DOMRect): Variants => {
  return {
    hidden: {
      width: '0dvh',
      height: '0dvh',
      left: boundings?.left,
      top: boundings?.top,
      pointerEvents: 'none',
      borderRadius: '50%',
      transition,
    },
    visible: {
      width: '100dvw',
      height: '100dvh',
      left: 0,
      top: 0,
      pointerEvents: 'all',
      borderRadius: '4px',
      transition,
    },
  };
};
